import FastestValidator, { ValidationRule, ValidationRuleName, ValidationRuleObject,
  ValidatorConstructorOptions } from 'fastest-validator';
import minMaxValidator from '@/utils/validator/validators/minMax.validator';
import StringValidator from '@/utils/validator/validators/string.validator';
import errorMessages from '@/utils/validator/error.messages';

const validatorOpts: ValidatorConstructorOptions = {
  useNewCustomCheckerFunction: true,
  messages: errorMessages,
  aliases: {
    minMaxPrice: minMaxValidator.alias,
  },
  defaults: {
    string: StringValidator.default,
  },
  customRules: {

  },
};
const validator = new FastestValidator(validatorOpts);

export default validator;
